// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fX1sb","left":"styles_left__1KlN0"};